import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { interceptConnections } from '../helpers/intercept-connections';
export var createNativeConstantSourceNodeFakerFactory = function createNativeConstantSourceNodeFakerFactory(createNativeAudioBufferSourceNode, createNativeGainNode) {
  return function (nativeContext, _ref) {
    var offset = _ref.offset,
        audioNodeOptions = _objectWithoutProperties(_ref, ["offset"]);

    var audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext);
    /*
     * @todo Edge will throw a NotSupportedError when calling createBuffer() on a closed context. That's why the audioBuffer is created
     * after the audioBufferSourceNode in this case. If the context is closed createNativeAudioBufferSourceNode() will throw the
     * expected error and createBuffer() never gets called.
     */

    var audioBuffer = nativeContext.createBuffer(1, 2, nativeContext.sampleRate);
    var gainNode = createNativeGainNode(nativeContext, _objectSpread({}, audioNodeOptions, {
      gain: offset
    })); // Bug #5: Safari does not support copyFromChannel() and copyToChannel().

    var channelData = audioBuffer.getChannelData(0); // Bug #95: Safari does not play or loop one sample buffers.

    channelData[0] = 1;
    channelData[1] = 1;
    audioBufferSourceNode.buffer = audioBuffer;
    audioBufferSourceNode.loop = true;
    audioBufferSourceNode.connect(gainNode);
    var nativeConstantSourceNodeFaker = {
      get bufferSize() {
        return undefined;
      },

      get channelCount() {
        return gainNode.channelCount;
      },

      set channelCount(value) {
        gainNode.channelCount = value;
      },

      get channelCountMode() {
        return gainNode.channelCountMode;
      },

      set channelCountMode(value) {
        gainNode.channelCountMode = value;
      },

      get channelInterpretation() {
        return gainNode.channelInterpretation;
      },

      set channelInterpretation(value) {
        gainNode.channelInterpretation = value;
      },

      get context() {
        return gainNode.context;
      },

      get inputs() {
        return undefined;
      },

      get numberOfInputs() {
        return audioBufferSourceNode.numberOfInputs;
      },

      get numberOfOutputs() {
        return gainNode.numberOfOutputs;
      },

      get offset() {
        return gainNode.gain;
      },

      get onended() {
        return audioBufferSourceNode.onended;
      },

      set onended(value) {
        audioBufferSourceNode.onended = value;
      },

      addEventListener: function addEventListener() {
        return audioBufferSourceNode.addEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      },
      dispatchEvent: function dispatchEvent() {
        return audioBufferSourceNode.dispatchEvent(arguments.length <= 0 ? undefined : arguments[0]);
      },
      removeEventListener: function removeEventListener() {
        return audioBufferSourceNode.removeEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      },
      start: function start() {
        var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        audioBufferSourceNode.start.call(audioBufferSourceNode, when);
      },
      stop: function stop() {
        var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        audioBufferSourceNode.stop.call(audioBufferSourceNode, when);
      }
    };
    return interceptConnections(nativeConstantSourceNodeFaker, gainNode);
  };
};